import { render, staticRenderFns } from "./QuestionsLoading.vue?vue&type=template&id=6f0bf9ff&scoped=true&"
import script from "./QuestionsLoading.vue?vue&type=script&lang=js&"
export * from "./QuestionsLoading.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsLoading.vue?vue&type=style&index=0&id=6f0bf9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bf9ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0bf9ff')) {
      api.createRecord('6f0bf9ff', component.options)
    } else {
      api.reload('6f0bf9ff', component.options)
    }
    module.hot.accept("./QuestionsLoading.vue?vue&type=template&id=6f0bf9ff&scoped=true&", function () {
      api.rerender('6f0bf9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/QuestionsLoading.vue"
export default component.exports